import React from "react";
import { secondaryColor } from "../../utils/constants";

export default function MenuClose({ color = secondaryColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.064" height="19.064" viewBox="0 0 19.064 19.064">
      <g id="Nav-Close" transform="translate(-67.468 -151.968)">
        <path
          id="Vereinigungsmenge_1"
          data-name="Vereinigungsmenge 1"
          d="M178.253-1387.767l-7.141-7.141-7.141,7.141a1.4,1.4,0,0,1-1.98,0,1.4,1.4,0,0,1,0-1.98l7.142-7.141-7.142-7.142a1.4,1.4,0,0,1,0-1.98,1.4,1.4,0,0,1,1.98,0l7.141,7.141,7.141-7.141a1.4,1.4,0,0,1,1.98,0,1.4,1.4,0,0,1,0,1.98l-7.142,7.142,7.142,7.141a1.4,1.4,0,0,1,0,1.98,1.394,1.394,0,0,1-.99.41A1.4,1.4,0,0,1,178.253-1387.767Z"
          transform="translate(-94.112 1558.388)"
          fill={color}
        />
      </g>
    </svg>
  );
}
